import React from 'react'
import './Paragraph.scss'
import { getStyles } from "src/helpers"

interface IParagraph extends React.HTMLAttributes<HTMLParagraphElement> {
    variant: 1 | 2 | 3
}

const Paragraph: React.FC<IParagraph> = (props) => {
    const { children, variant, className } = props

    const styles = getStyles("paragraph", [variant], className)

    return (
        <p
            className={styles}
        >
            {children}
        </p>
    )
}

export default Paragraph